/**
 * `SocialRoom`'s protocol (design/v2.md §2.3).
 *
 * The shape of this file is the whole privacy decision, so it is worth reading
 * the absence as much as the presence: `SocialState` carries **one aggregate
 * number and no identities**. A Colyseus schema is broadcast to every client in
 * the room, and every signed-in player is in this room — so anything put in that
 * schema is published to the entire site. Presence therefore travels as
 * `client.send`, addressed to accepted friends, exactly the way `hand.private`
 * travels to one seat (backend.md §3.2).
 *
 * `room.invited` is the one message that carries a room id, and it is sent only
 * to somebody a seated player just invited.
 */
/** `gameServer.define()` name for the presence/notification room. */
export const SOCIAL_ROOM_NAME = 'social';
//# sourceMappingURL=social.js.map